export default {
  // ID
  id: null,
  // HANDLE SHOPIFY
  handleShopify: null,
  // HANDLE
  handle: null,
  // LOCALE
  locale: null,
  // TITLE
  title: null,
  // DESCRIPTION
  description: null,
  // INTERNAL_TYPE
  internal_type: null,
  // INTERNAL_COLOR_CODE
  internal_color_code: null,
  // FEATURES
  features: null,
  // PRICE
  price: null,
  // STRIKEOUT_PRICE
  strikeout_price: null,
  // CURRENCY
  currency: null,
  // AVAILABILITY
  availability: null,
  // COLORS
  colors: [
    // {
    //   internal_color_code: null,
    //   availability: null,
    //   normalized_color: null,
    //   sample_color: null,
    //   image: null,
    //   internal_type: null,
    // },
  ],
  // SIZES
  sizes: [
    // {
    //   name: null,
    //   availability: null,
    //   id: null,
    //   barcode: null,
    //   sku: null,
    // },
  ],
  // IMAGES, VIDEOS
  medias: [
    // {
    //   src: null,
    //   type: null,
    //   position: null,
    // },
  ],
  // FLAPS
  flaps: [],
  // NORMALIZED_COLOR
  normalized_color: null,
  // SAMPLE_COLOR
  sample_color: null,
  // IS_PETS_PRODUCT
  isPetsProduct: null,
  // ICONS
  icons: [
    // "",
  ],
  // MODEL_SIZE_DATA
  model_size_data: null,
  // FITTING GUIDE
  fitting_guide: null,
  // TAGS
  tag: [
    // "",
  ],
  // GENDER
  gender: null,
  // SIZE & FIT
  size_details: {
    // TOP_CUT
    top_cut: null,
    // BOTTOM_CUT
    bottom_cut: null,
    // FIT_INTENTION
    fit_intention: null,
    // FIT_DETAILS
    fit_details: null,
    // WAIST_TYPE
    waist_type: null,
    // LEG_SHAPE
    leg_shape: null,
    // THICKNESS
    thickness: null,
    // BACK_LENGTH
    back_length: null,
    // INSIDE_LEG_MEASUREMENT
    inside_leg_measurement: null,
    // LENGTH_INFORMATION
    length_information: null,
    // MODEL_SIZE_DATA
    model_size_data: null,
    // DIMENSIONS
    dimensions: {
      // DEFAULT
      default: null,
      // WIDTH
      width: null,
      // HEIGHT
      height: null,
      // DEPTH
      depth: null,
      // TOP HANDLE DROP LENGTH
      top_handle_drop_length: null,
      // ADJUSTABLE SHOULDER STRAP DROP LENGTH
      adjustable_shoulder_strap_drop_length: null,
      // STRAP LENGTH
      strap_length: null,
      // CAPACIY
      capacity: null,
    },
  },
  // MATERIALS
  materials: {
    // COMPOSITION
    composition: null,
    // CARE INSTRUCTIONS
    care_instructions: [],
  },
  // SEO
  seo: {
    title: null,
    // META_DESC
    description: null,
    // META_OG_IMAGE
    og_image: null,
  },
  product_ids: [],
}
